import { ThemeProvider } from 'styled-components'
import OpenInApp from '../../open-in-app'
import ShareModal from '../primary/share/share-modal'
import Overlay from '../../../shared/overlay'
import InfoModal from '../secondary/info-modal'
import EditModal from '../primary/edit/edit-modal'
import styled from 'styled-components'

import { withGifDetailContext, Modals } from '../gif-detail-context'
import { getContentOfGif, getCreatorOfGif, setGADataLayer } from 'analytics'

const OpenInAppContainer = styled.div`
    position: fixed;
    width: 100%;
    justify-content: center;
    display: flex;
    margin-bottom: 25px;
    bottom: 0;
`

const OverlayManager = ({ rendition, modal, setModal, gif, slug, url }) => {
    const closeOverlay = () => {
        if (Modals.SHARE === modal) {
            setGADataLayer({
                event: 'share_close',
                options: {
                    content: getContentOfGif(gif),
                    creator: getCreatorOfGif(gif),
                },
            })
        }

        setModal(undefined)
    }
    const getModalComponent = () => {
        switch (modal) {
            case Modals.SHARE:
                return <ShareModal {...{ rendition, gif, slug, url }} />
            case Modals.INFO:
                return <InfoModal {...{ gif, rendition }} />
            case Modals.EDIT:
                return <EditModal {...{ gif }} />
            default:
                return null
        }
    }

    if (modal === Modals.SHARE || modal === Modals.INFO || modal === Modals.EDIT) {
        return (
            <ThemeProvider
                theme={{
                    headerHeight: 60,
                    closeMarginLeft: 12,
                }}
            >
                <Overlay closeOverlay={closeOverlay} hideCancel={modal === Modals.EDIT}>
                    {getModalComponent()}
                </Overlay>
            </ThemeProvider>
        )
    }
    return (
        <OpenInAppContainer>
            <OpenInApp category="GIF Detail" slug={slug} />
        </OpenInAppContainer>
    )
}

export default withGifDetailContext(OverlayManager)
